import Project from './projects--entry.js';

function Projects() {
	const projectsElement = document.querySelector('.projects');
	const mainnavEntryLinkElement = document.querySelector('.mainnav--entry-projects .mainnav--entry--link');
	const projectsSubnavElement = projectsElement.querySelector('.subnav-projects');
	const projectsSubnavAElements = projectsSubnavElement.querySelectorAll('a');
	const projectsSubnavButtonElement = projectsElement.querySelector('button');
	const projectsListElement = projectsElement.querySelector('.projects--list');
	const projectsListItemElements = projectsListElement.querySelectorAll('.projects--list--item');
	const projects_items = [];

	function open() {
		BODY_ELEMENT.classList.add('body-projects');
		MAINNAV_ELEMENT.classList.add('subpage');
		mainnavEntryLinkElement.classList.add('active');
		filterElements();
		openCloseProject();
	}

	function close() {
		BODY_ELEMENT.classList.remove('body-projects');
		MAINNAV_ELEMENT.classList.remove('subpage');
		mainnavEntryLinkElement.classList.remove('active');
	}

	function initProjectsItems() {
		[...projectsListItemElements].forEach((projectListItemElement) => {
			projects_items.push(new Project(projectListItemElement.dataset.id));
		});
	}

	function openCloseProject() {
		let project_id;
		const hash = location.hash.substr(2);

		if (hash.indexOf('/') !== -1) {
			project_id = hash.slice(hash.indexOf('/') + 1);
		}

		[...projects_items].forEach((project) => {
			if (project_id && project.id === project_id) {
				project.open();
			} else {
				project.close();
			}
		});

		if (project_id) {
			BODY_ELEMENT.classList.add('body-projects-entry');
		} else {
			BODY_ELEMENT.classList.remove('body-projects-entry');
		}
	}

	function updateSubnav(filter) {
		[...projectsSubnavAElements].forEach((element) => {
			if (filter && element.href.indexOf(filter) !== -1) {
				element.classList.add('active');
			} else {
				element.classList.remove('active');
			}
		});
	}

	function positionElement(element, i) {
		let widthOfElement;
		if (window.innerWidth < 1120 && window.innerWidth > 1024) {
			element.style.left = `${i % 3 * 33.3333}%`;
			widthOfElement = element.offsetWidth;
			element.style.top = `${Math.floor(i / 3) * widthOfElement}px`;
			element.style.height = `${widthOfElement}px`;
		} else if (window.innerWidth >= 1120) {
			element.style.left = `${i % 4 * 15}em`;
			element.style.top = `${Math.floor(i / 4) * 15}em`;
			element.style.height = null;
		}
		setHeightOfProjectsListElement(widthOfElement, i);
	}

	function setHeightOfProjectsListElement(height, i) {
		if (window.innerWidth < 1120 && window.innerWidth > 1024) {
			projectsListElement.style.height = `${Math.ceil((i + 1) / 3) * height}px`;
		} else if (window.innerWidth >= 1120) {
			projectsListElement.style.height = `${Math.ceil((i + 1) / 4) * 15}em`;
		} else {
			projectsListElement.style.height = null;
		}
	}

	function filterElements() {
		let filter;
		const hash = location.hash.substr(2);

		if (hash.indexOf(':') !== -1) {
			filter = hash.slice(hash.indexOf(':') + 1);
		}

		const height = 0;
		let i = 0;
		[...projectsListItemElements].forEach((element, key) => {
			if (filter && element.dataset.categories.indexOf(filter) === -1) {
				element.hidden = true;
				element.style.top = null;
				element.style.height = null;
				element.style.left = null;
				setTimeout(() => {
					element.style.display = 'none';
				}, 250);
			} else {
				element.style.display = null;
				element.offsetWidth;
				element.hidden = false;
				positionElement(element, i);
				i++;
			}
			if (filter) {
				element.querySelector('a').href = '#!' + `projects:${filter}/${element.dataset.id}`;
			} else {
				element.querySelector('a').href = '#!' + 'projects' + `/${element.dataset.id}`;
			}
		});

		if (projectsSubnavElement.classList.contains('active')) {
			projectsSubnavElement.classList.remove('active');
		}

		updateSubnav(filter);
	}

	function showHideSubnav() {
		if (projectsSubnavElement.classList.contains('active')) {
			projectsSubnavElement.classList.remove('active');
		} else {
			projectsSubnavElement.classList.add('active');
		}
	}

	window.addEventListener('resize', () => {
		let i = 0;
		[...projectsListItemElements].forEach((element) => {
			if (!element.hidden) {
				positionElement(element, i);
				i++;
			} else {
				element.style.top = null;
				element.style.height = null;
				element.style.left = null;
			}
		});
	});

	projectsSubnavButtonElement.addEventListener('click', showHideSubnav);

	initProjectsItems();

	this.open = open;
	this.close = close;
}

export default Projects;
